import { InnerBlocks } from '@wordpress/block-editor';

const OneColumnDeprecatedV1 = {
  save: ( { attributes } ) => {
    let className = 'wp-block-abs-content-one-column-block undefined';
    if (attributes.inverseStyling) className += ' inverted';

    return (
      <div className={className}>
        <div className="container">
          <div className="row">
            <div className="col">
              <InnerBlocks.Content />
            </div>
          </div>
        </div>
      </div>
    );
  },
};

export default OneColumnDeprecatedV1;
